import { createContext, useContext, useState } from "react";

const TooltipModeContext = createContext();

export function TooltipModeProvider({ children }) {
  const [mode, setMode] = useState("detailed"); // "simple" | "detailed"

  return (
    <TooltipModeContext.Provider value={{ mode, setMode }}>
      {children}
    </TooltipModeContext.Provider>
  );
}

export function useTooltipMode() {
  return useContext(TooltipModeContext);
}
